document.addEventListener('DOMContentLoaded', function () {
    const subscriptionWrapper = document.querySelector('.product-subscription-bundles');
    if (!subscriptionWrapper) return;

    const oneTimePurchase = subscriptionWrapper.querySelector('.product-subscription__item[data-place="0"]');
    const subscribeAndSaveTrigger = subscriptionWrapper.querySelector('.subscription-collapsable-trigger');
    const subscriptionOptionsContainer = subscriptionWrapper.querySelector('.product-subscription-options__cont');
    const dropdown = subscriptionWrapper.querySelector('.product-subscription-dropdown');
    const frequencySelect = subscriptionWrapper.querySelector('#bundle-delivery-frequency');
    const oneTimeRadio = oneTimePurchase?.querySelector('input[type="radio"]');
    const subscribeRadio = subscribeAndSaveTrigger?.querySelector('input[type="radio"]');

    if (!oneTimePurchase || !subscribeAndSaveTrigger || !frequencySelect) return;

    function selectedOption() {
        return frequencySelect.options[frequencySelect.selectedIndex];
    }

    function applySellingPlan(option) {
        const sellingPlanInput = document.getElementById('selling_plan');
        if (!sellingPlanInput || !option) return;
        sellingPlanInput.value = option.value || '';
    }

    function updateDynamicSubscriptionPrice(option) {
        const dynamicPriceEl = subscriptionWrapper.querySelector('.dynamic-subscription-price');
        if (!dynamicPriceEl || !option) return;
        const price = option.getAttribute('data-price');
        if (price) dynamicPriceEl.textContent = price;
    }

    function setPurchaseMode(mode) {
        const isSubscribe = mode === 'subscribe';

        oneTimePurchase.classList.toggle('product-subscription__item--active', !isSubscribe);
        subscribeAndSaveTrigger.classList.toggle('product-subscription__item--active', isSubscribe);
        subscriptionOptionsContainer.classList.toggle('active', isSubscribe);
        dropdown.classList.toggle('active', isSubscribe);

        if (oneTimeRadio) oneTimeRadio.checked = !isSubscribe;
        if (subscribeRadio) subscribeRadio.checked = isSubscribe;

        if (isSubscribe) {
            const option = selectedOption();
            applySellingPlan(option);
            updateDynamicSubscriptionPrice(option);
            if (typeof updateBottlePriceOriginal === 'function' && option?.dataset.place) {
                updateBottlePriceOriginal(parseInt(option.dataset.place, 10));
            }
        } else {
            const sellingPlanInput = document.getElementById('selling_plan');
            if (sellingPlanInput) sellingPlanInput.value = '';
            if (typeof updateBottlePriceOriginal === 'function') {
                updateBottlePriceOriginal(0);
            }
        }
    }

    oneTimeRadio?.addEventListener('change', function () {
        if (oneTimeRadio.checked) setPurchaseMode('onetime');
    });

    subscribeRadio?.addEventListener('change', function () {
        if (subscribeRadio.checked) setPurchaseMode('subscribe');
    });

    frequencySelect.addEventListener('change', function () {
        setPurchaseMode('subscribe');
    });

    setPurchaseMode(subscribeRadio?.checked ? 'subscribe' : 'onetime');
});
